import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { CrisisBanner } from "@/components/CrisisBanner";
import { DisclaimerBanner } from "@/components/DisclaimerBanner";
import Auth from "@/pages/Auth";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Feed from "@/pages/Feed";
import PostDetail from "@/pages/PostDetail";
import Profile from "@/pages/Profile";
import Admin from "@/pages/Admin";
import Subscribe from "@/pages/Subscribe";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <CrisisBanner />
          <DisclaimerBanner />
          <Routes>
            <Route path="/login" element={<Auth mode="login" />} />
            <Route path="/register" element={<Auth mode="register" />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/" element={<ProtectedRoute><Feed /></ProtectedRoute>} />
            <Route path="/post/:id" element={<ProtectedRoute><PostDetail /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            <Route path="/subscribe" element={<ProtectedRoute><Subscribe /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" toastOptions={{ style: { borderRadius: "9999px", background: "#fff", border: "1px solid #E6EBE4", color: "#2C362B" } }} />
      </AuthProvider>
    </div>
  );
}

export default App;
